import style from './index.module.scss';
import template from '@styles/reusable.styles.module.scss';
import { ITechnologies } from '@components/main-page/main-page.state';
import { useState } from 'react';
import { TechnologiesTable } from './technologies-table';
import { TabSlider } from '@components/shared/tab-slider/tab-slider';

interface ITechnologiesSectionProps {
  title: string;
  technologies: ITechnologies[];
}

const TechnologiesSection = ({ title, technologies }: ITechnologiesSectionProps) => {
  const [activeIndex, setActiveIndex] = useState(0);
  return (
    <section className={`${template.section} ${template.section_light}`}>
      <div className={`${template.container} ${template.container_small} ${style.container}`}>
        <h2 className={`${template.title} ${style.title}`}>{title}</h2>
      </div>
      <div className={`${template.container} ${template.container_large}`}>
        <TabSlider items={technologies} activeIndex={activeIndex} onChange={setActiveIndex} />
        <div className={`${style.technologies__table}`}>
          {technologies.map((item: ITechnologies, index: number) => {
            return (
              <TechnologiesTable
                key={index}
                title={item.title}
                technologies={item.items}
                isActive={technologies[activeIndex].title}
              />
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TechnologiesSection;
